import { render, staticRenderFns } from "./date_value.vue?vue&type=template&id=3f521050&lang=pug"
import script from "./date_value.vue?vue&type=script&lang=js"
export * from "./date_value.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports